import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { theme } from "styles/mui-config";

export const SingleAreaChart = ({ data, keyX, keyY, title, name }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            display: payload[0].value ? "block" : "none",
            background: "white",
            textAlign: "center",
            padding: "0 10px",
          }}
        >
          <p className="label" style={{ margin: "0" }}>{`${"نمره"} : ${
            payload[0].value
          }`}</p>
          <p className="label" style={{ margin: "0" }}>{`${label}`}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div style={{ width: "100%" }}>
      <p>{title ?? ""}</p>

      <ResponsiveContainer width="100%" height={200}>
        <AreaChart
          width={500}
          height={200}
          data={data}
          syncId="anyId"
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={keyX} />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey={keyY}
            stroke={theme.palette.primary.main}
            fill={theme.palette.primary.main}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
export default SingleAreaChart;
